var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgT7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4922 28.0088C14.4922 27.4239 14.943 26.9419 15.5258 26.8934C21.8537 26.3666 26.842 21.0481 26.842 14.5865C26.842 8.12474 21.8536 2.80615 15.5255 2.27947C14.9429 2.23096 14.4922 1.74908 14.4922 1.16442V0C18.2573 0 21.8047 1.41685 24.5253 3.99843C27.5894 6.90585 29.2494 11.0208 29.0644 15.2407C28.9043 18.8914 27.4066 22.3004 24.8064 24.9007C22.3363 27.3708 19.1363 28.8459 15.6927 29.1246C15.0448 29.177 14.4922 28.6589 14.4922 28.0088Z",
    fill: "url(#paint0_radial_152_535)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6932 29.1249C19.1367 28.8462 22.3367 27.3711 24.8068 24.901C27.4071 22.3007 28.9048 18.8916 29.0649 15.241C29.068 15.1696 29.0692 15.0982 29.0713 15.0267C28.9575 11.1878 27.3304 7.51478 24.5258 4.85357C22.0983 2.5502 19.0128 1.17401 15.7016 0.904145C15.2018 0.863424 14.7581 1.15795 14.5783 1.59227C14.7354 1.96968 15.0943 2.24388 15.526 2.27983C21.8541 2.80651 26.8425 8.1251 26.8425 14.5868C26.8425 14.73 26.8392 14.8723 26.8343 15.0143C26.8392 15.1562 26.8425 15.2986 26.8425 15.4417C26.8425 21.9033 21.8542 27.2218 15.5263 27.7486C15.0943 27.7846 14.7352 28.059 14.5781 28.4367C14.7568 28.8694 15.1964 29.1651 15.6932 29.1249Z",
    fill: "url(#paint1_linear_152_535)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4219 2.26592C15.4548 2.27157 15.488 2.27621 15.5218 2.27897C16.2977 2.34354 17.0532 2.48057 17.782 2.68249L15.4219 0.322266V2.26592Z",
    fill: "url(#paint2_linear_152_535)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0019 3.91046H12.9766V1.51266C12.9766 0.677208 13.6538 0 14.4892 0C15.3246 0 16.0019 0.677208 16.0019 1.51266V3.91046Z",
    fill: "url(#paint3_linear_152_535)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9766 25.2178H16.0019V29.1282H12.9766V25.2178Z",
    fill: "url(#paint4_linear_152_535)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0019 25.2178H12.9766V26.055L16.0019 29.0803V25.2178Z",
    fill: "url(#paint5_linear_152_535)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4886 26.153C20.8768 26.153 26.0554 20.9744 26.0554 14.5863C26.0554 8.19814 20.8768 3.01953 14.4886 3.01953C8.10048 3.01953 2.92188 8.19814 2.92188 14.5863C2.92188 20.9744 8.10048 26.153 14.4886 26.153Z",
    fill: "url(#paint6_linear_152_535)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6364 8.50294C22.2395 8.21136 21.8187 7.94401 21.3776 7.70112C21.1347 7.26008 20.8674 6.83919 20.5758 6.44226C18.9567 4.23822 16.7961 3.02441 14.492 3.02441C12.1878 3.02441 10.0272 4.23822 8.40815 6.44226C8.11657 6.83919 7.84922 7.26002 7.60633 7.70106C7.1653 7.94388 6.74446 8.2113 6.34754 8.50288C4.14349 10.122 2.92969 12.2826 2.92969 14.5867C2.92969 16.8908 4.14349 19.0515 6.34754 20.6705C6.74446 20.9621 7.1653 21.2295 7.60633 21.4724C7.84915 21.9134 8.11657 22.3343 8.40815 22.7311C10.0272 24.9352 12.1879 26.149 14.492 26.149C16.7961 26.149 18.9568 24.9352 20.5758 22.7311C20.8674 22.3342 21.1348 21.9134 21.3776 21.4723C21.8187 21.2295 22.2395 20.962 22.6364 20.6705C24.8405 19.0514 26.0543 16.8908 26.0543 14.5866C26.0543 12.2825 24.8405 10.122 22.6364 8.50294ZM14.492 25.6048C13.857 25.6048 13.1839 24.6589 12.6519 23.0449C13.255 23.1159 13.8697 23.1527 14.492 23.1527C15.1143 23.1527 15.7291 23.1159 16.3321 23.0449C15.8 24.6589 15.127 25.6048 14.492 25.6048ZM14.492 22.6083C13.804 22.6083 13.1308 22.5617 12.4774 22.4734C12.1148 21.1913 11.8515 19.6522 11.7008 17.9718C12.6028 18.0363 13.5386 18.0695 14.492 18.0695C15.4453 18.0695 16.3811 18.0362 17.2831 17.9718C17.1325 19.6522 16.8693 21.1913 16.5066 22.4734C15.8532 22.5617 15.18 22.6083 14.492 22.6083ZM14.492 3.56879C15.127 3.56879 15.8 4.51467 16.3321 6.12866C15.729 6.0577 15.1143 6.02093 14.492 6.02093C13.8696 6.02093 13.255 6.0577 12.6519 6.12866C13.184 4.51467 13.857 3.56879 14.492 3.56879ZM14.492 6.56531C15.18 6.56531 15.8532 6.61193 16.5066 6.70015C16.8692 7.98234 17.1325 9.52142 17.2831 11.2018C16.3811 11.1373 15.4454 11.1041 14.492 11.1041C13.5386 11.1041 12.6028 11.1374 11.7008 11.2018C11.8515 9.52142 12.1147 7.98228 12.4774 6.70015C13.1308 6.61186 13.804 6.56531 14.492 6.56531ZM11.5536 14.5868C11.5536 13.6164 11.5886 12.6653 11.656 11.7509C12.5704 11.6834 13.5215 11.6484 14.492 11.6484C15.4625 11.6484 16.4135 11.6834 17.328 11.7509C17.3954 12.6653 17.4305 13.6164 17.4305 14.5868C17.4305 15.5573 17.3954 16.5084 17.328 17.4228C16.4135 17.4902 15.4625 17.5252 14.492 17.5252C13.5215 17.5252 12.5704 17.4902 11.656 17.4228C11.5886 16.5083 11.5536 15.5573 11.5536 14.5868ZM11.107 17.3779C9.42663 17.2273 7.88749 16.9641 6.60536 16.6014C6.51708 15.948 6.47052 15.2748 6.47052 14.5868C6.47052 13.8988 6.51714 13.2256 6.60536 12.5721C7.88749 12.2095 9.42663 11.9463 11.107 11.7956C11.0425 12.6976 11.0093 13.6334 11.0093 14.5868C11.0093 15.5402 11.0425 16.476 11.107 17.3779ZM17.877 11.7957C19.5574 11.9463 21.0965 12.2096 22.3787 12.5722C22.4669 13.2256 22.5135 13.8988 22.5135 14.5868C22.5135 15.2748 22.4669 15.948 22.3787 16.6014C21.0965 16.9641 19.5574 17.2273 17.877 17.378C17.9415 16.476 17.9747 15.5402 17.9747 14.5868C17.9748 13.6334 17.9415 12.6976 17.877 11.7957ZM17.8334 11.2454C17.69 9.59834 17.4402 8.07947 17.0963 6.79226C18.5157 7.04368 19.8283 7.49563 20.9741 8.1047C21.5831 9.25055 22.0351 10.5631 22.2866 11.9825C20.9993 11.6386 19.4805 11.3888 17.8334 11.2454ZM11.1506 11.2454C9.50355 11.3888 7.98468 11.6386 6.69747 11.9825C6.94889 10.563 7.40084 9.25048 8.00991 8.10463C9.15576 7.49563 10.4683 7.04361 11.8877 6.79226C11.5438 8.07954 11.294 9.59834 11.1506 11.2454ZM6.03388 16.427C4.41988 15.8949 3.474 15.2218 3.474 14.5868C3.474 13.9518 4.41988 13.2788 6.03388 12.7467C5.96291 13.3498 5.92614 13.9645 5.92614 14.5868C5.92614 15.2091 5.96297 15.8238 6.03388 16.427ZM11.1506 17.9281C11.294 19.5752 11.5438 21.0941 11.8877 22.3813C10.4683 22.1299 9.1557 21.6779 8.00984 21.0689C7.40084 19.923 6.94882 18.6105 6.69741 17.1911C7.98475 17.535 9.50355 17.7848 11.1506 17.9281ZM17.8334 17.9281C19.4805 17.7848 20.9993 17.535 22.2866 17.1911C22.0351 18.6105 21.5832 19.923 20.9741 21.0689C19.8283 21.6779 18.5157 22.1299 17.0963 22.3813C17.4402 21.0941 17.69 19.5753 17.8334 17.9281ZM22.9501 12.7467C24.5641 13.2788 25.51 13.9518 25.51 14.5868C25.51 15.2218 24.5641 15.8948 22.9501 16.427C23.0211 15.8238 23.0579 15.2091 23.0579 14.5868C23.0578 13.9645 23.021 13.3497 22.9501 12.7467ZM25.3815 13.361C24.8489 12.9068 24.0046 12.4985 22.8679 12.1492C22.67 10.896 22.3196 9.70187 21.8292 8.60823C23.6902 9.82002 24.9845 11.4841 25.3815 13.361ZM20.4706 7.24967C19.3769 6.75925 18.1829 6.40882 16.9296 6.21086C16.5803 5.07411 16.172 4.22987 15.7178 3.69729C17.5947 4.09434 19.2588 5.38865 20.4706 7.24967ZM13.2662 3.69729C12.812 4.22987 12.4038 5.07411 12.0544 6.21086C10.8011 6.40882 9.60702 6.75919 8.51331 7.24967C9.72517 5.38865 11.3893 4.09434 13.2662 3.69729ZM7.15488 8.60816C6.66446 9.70181 6.31403 10.8959 6.11613 12.1492C4.97938 12.4986 4.13515 12.9068 3.60257 13.361C3.99955 11.4841 5.2938 9.82002 7.15488 8.60816ZM3.6025 15.8126C4.13508 16.2668 4.97932 16.675 6.11607 17.0244C6.31403 18.2777 6.6644 19.4717 7.15482 20.5654C5.2938 19.3536 3.99955 17.6895 3.6025 15.8126ZM8.51337 21.9239C9.60702 22.4143 10.8011 22.7648 12.0545 22.9627C12.4038 24.0995 12.812 24.9437 13.2663 25.4763C11.3893 25.0793 9.72517 23.785 8.51337 21.9239ZM15.7178 25.4762C16.172 24.9437 16.5803 24.0994 16.9296 22.9627C18.1829 22.7647 19.377 22.4143 20.4706 21.9239C19.2588 23.7849 17.5947 25.0793 15.7178 25.4762ZM21.8291 20.5654C22.3196 19.4718 22.67 18.2777 22.8679 17.0244C24.0046 16.6751 24.8488 16.2668 25.3814 15.8127C24.9845 17.6895 23.6902 19.3536 21.8291 20.5654Z",
    fill: "url(#paint7_linear_152_535)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4889 24.9114C20.1911 24.9114 24.8137 20.2888 24.8137 14.5866C24.8137 8.8843 20.1911 4.26172 14.4889 4.26172C8.78665 4.26172 4.16406 8.8843 4.16406 14.5866C4.16406 20.2888 8.78665 24.9114 14.4889 24.9114Z",
    fill: "url(#paint8_linear_152_535)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4145 15.0687L13.8622 15.5164C14.026 15.6802 14.118 15.9023 14.118 16.1339C14.118 16.6163 14.5091 17.0072 14.9913 17.0072C15.4943 17.0072 15.9021 17.415 15.9021 17.918C15.9021 18.572 15.7656 19.2189 15.5014 19.8171L13.8893 23.468C13.6686 23.9678 13.0147 24.09 12.6284 23.7037C12.0653 23.1406 11.749 22.377 11.749 21.5807V21.156C11.749 20.0489 11.3092 18.9872 10.5264 18.2043L10.4787 18.1566C9.74199 17.4199 9.32812 16.4207 9.32812 15.3788V15.2266C9.32812 14.5039 9.91398 13.918 10.6367 13.918C11.6786 13.9181 12.6777 14.332 13.4145 15.0687Z",
    fill: "url(#paint9_linear_152_535)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5086 3.72263C7.61259 4.78339 5.25921 6.96912 3.9772 9.75055C3.82523 10.0801 3.75 10.44 3.75 10.803C3.75 11.479 4.01855 12.1274 4.4966 12.6054L4.73303 12.8419C5.79242 13.9013 7.22928 14.4964 8.72744 14.4964C8.95126 14.4964 9.13271 14.3149 9.13271 14.0911C9.13271 13.8673 8.95126 13.6859 8.72744 13.6859H7.48164C6.90708 13.6859 6.44133 13.2201 6.44133 12.6455C6.44133 12.071 6.90708 11.6052 7.48164 11.6052H8.45463C9.62131 11.6052 10.7402 11.1417 11.5652 10.3167L13.0675 8.81439C13.3947 8.48724 13.8383 8.30346 14.301 8.30346C14.9703 8.30346 15.5806 7.92052 15.8717 7.31792C16.2286 6.57935 15.6905 5.72181 14.8703 5.72181H12.9319C12.362 5.72181 11.9001 5.25982 11.9001 4.68997C11.9001 3.97078 11.1839 3.47522 10.5086 3.72263Z",
    fill: "url(#paint10_linear_152_535)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8752 5.72158H12.9369C12.3669 5.72158 11.905 5.25958 11.905 4.68973C11.905 4.65585 11.9029 4.62266 11.8998 4.58984C8.12098 5.56678 5.18162 8.62969 4.38281 12.477C4.42096 12.5208 4.46018 12.5638 4.50153 12.6052L4.73795 12.8416C5.79734 13.901 7.2342 14.4962 8.73237 14.4962C8.95618 14.4962 9.13764 14.3147 9.13764 14.0909C9.13764 13.8671 8.95618 13.6856 8.73237 13.6856H7.48656C6.912 13.6856 6.44625 13.2199 6.44625 12.6452C6.44625 12.0706 6.912 11.6049 7.48656 11.6049H8.45955C9.62623 11.6049 10.7452 11.1414 11.5701 10.3164L13.0724 8.8141C13.3996 8.48694 13.8433 8.30316 14.306 8.30316C14.9752 8.30316 15.5855 7.92023 15.8766 7.31762C16.2335 6.57911 15.6955 5.72158 14.8752 5.72158Z",
    fill: "url(#paint11_linear_152_535)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7861 12.0943C25.6264 11.367 24.976 10.8525 24.2314 10.8525H22.6008H21.7292C20.2478 10.8525 19.0469 12.0535 19.0469 13.5349V13.8612C19.0469 15.1624 20.1017 16.2172 21.4029 16.2172C22.0645 16.2172 22.6008 16.7536 22.6008 17.4152V20.5433C22.6008 21.3585 23.6593 21.6832 24.1123 21.0055C25.0537 19.5971 25.6941 17.9703 25.9416 16.2172C26.0164 15.6847 26.0554 15.14 26.0554 14.5866C26.0554 13.7308 25.9624 12.897 25.7861 12.0943Z",
    fill: "url(#paint12_linear_152_535)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8163 9.36703H21.3612C20.7432 9.36703 20.2422 8.86601 20.2422 8.24797C20.2422 7.62993 20.7432 7.12891 21.3612 7.12891H23.3335C23.91 7.81164 24.409 8.56232 24.8163 9.36703Z",
    fill: "url(#paint13_linear_152_535)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6616 4.23926C20.4417 5.79621 20.8815 7.55333 20.8815 9.41341C20.8815 15.8015 15.7029 20.9802 9.31477 20.9802C7.4547 20.9802 5.69758 20.5404 4.14062 19.7603C6.03973 23.5506 9.95942 26.1529 14.4875 26.1529C20.8757 26.1529 26.0543 20.9743 26.0543 14.5861C26.0542 10.0581 23.4519 6.13836 19.6616 4.23926Z",
    fill: "url(#paint14_linear_152_535)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3751 31.6661H7.60536C7.23654 31.6661 6.9375 31.3671 6.9375 30.9982V28.9765C6.9375 28.6076 7.23654 28.3086 7.60536 28.3086H21.3751C21.744 28.3086 22.043 28.6076 22.043 28.9765V30.9982C22.043 31.3671 21.744 31.6661 21.3751 31.6661Z",
    fill: "url(#paint15_linear_152_535)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3764 31.9998H6.60536C6.23654 31.9998 5.9375 31.7008 5.9375 31.3319V30.9541C5.9375 30.1715 6.57192 29.5371 7.35447 29.5371H21.6273C22.4098 29.5371 23.0443 30.1715 23.0443 30.9541V31.3319C23.0442 31.7008 22.7452 31.9998 22.3764 31.9998Z",
    fill: "url(#paint16_linear_152_535)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_152_535",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.8117 14.1402) scale(14.663 14.663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#FFD844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6924,
    stopColor: "#FFD140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#FFC639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9279,
    stopColor: "#FFB52F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_152_535",
    x1: 21.6493,
    y1: 10.189,
    x2: 23.6942,
    y2: -9.30191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCEE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_152_535",
    x1: 17.8233,
    y1: 2.34736,
    x2: 14.2468,
    y2: 0.778751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_152_535",
    x1: 13.5048,
    y1: 1.62071,
    x2: 16.0184,
    y2: 3.41007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_152_535",
    x1: 13.2826,
    y1: 28.0319,
    x2: 16.1589,
    y2: 25.9844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_152_535",
    x1: 16.4884,
    y1: 27.8644,
    x2: 12.3786,
    y2: 23.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_152_535",
    x1: 8.88737,
    y1: 8.98496,
    x2: 22.9066,
    y2: 23.0042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A98F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_152_535",
    x1: 16.2598,
    y1: 27.3214,
    x2: 12.0979,
    y2: -2.65897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65E1DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_152_535",
    x1: 16.9862,
    y1: 17.0838,
    x2: 5.46176,
    y2: 5.55941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65E1DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_152_535",
    x1: 7.1446,
    y1: 15.1892,
    x2: 25.3691,
    y2: 28.1203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_152_535",
    x1: 10.8531,
    y1: 9.95039,
    x2: 29.0776,
    y2: 22.8815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_152_535",
    x1: 11.6564,
    y1: 10.9007,
    x2: 6.49356,
    y2: 5.73789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_152_535",
    x1: 20.8034,
    y1: 15.5732,
    x2: 28.9703,
    y2: 17.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_152_535",
    x1: 22.101,
    y1: 8.21333,
    x2: 30.268,
    y2: 9.65013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_152_535",
    x1: 16.6141,
    y1: 15.8109,
    x2: 32.5132,
    y2: -13.7592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0469BC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_152_535",
    x1: 14.4903,
    y1: 28.7582,
    x2: 14.4903,
    y2: 30.1723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_152_535",
    x1: 14.4908,
    y1: 30.2584,
    x2: 14.4908,
    y2: 32.6682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgT7);
export default __webpack_public_path__ + "static/media/t7.9c288f5af333a04d968d6d726fdb93fd.svg";
export { ForwardRef as ReactComponent };